// extracted by mini-css-extract-plugin
export var cardIcon = "_7q-5";
export var checkboxCard = "_7q-0";
export var checkboxCardSelected = "_7q-4";
export var disabled = "_7q-2";
export var interactive = "_7q-1";
export var outerBorder = "_7q-3";
export var spacerMedium = "_7q-8";
export var spacerSmall = "_7q-7";
export var spacerXsmall = "_7q-6";